import { Box, BoxProps } from '@mui/system'
import type { FC, PropsWithChildren } from 'react'

type EqualColumnsGridProps = BoxProps & {
  gap?: string
}

/**
 * This is a basic `display: grid` container component that will make all of its direct children have equal width columns.
 * MUI's "Grid" component is overkill and also geared towards 12 column responsive layouts, so this is a simpler alternative.
 */
export const EqualColumnsGrid: FC<PropsWithChildren<EqualColumnsGridProps>> = ({ children, ...props }) => {
  const { sx = {}, ...rest } = props
  return (
    <Box
      {...rest}
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: '1fr',
        gap: props.gap || 'var(--spacing-2xs)',
        ...sx
      }}
    >
      {children}
    </Box>
  )
}
